// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"1671": "js-legacy","8626": "head-common","878": "stage_automation_icon","9474": "vendor",}[chunkId] || chunkId) + "-" + {"1671": "f5aff43989afbcaa","3353": "d8a6fcbe4a198eab","4276": "5cc9f4bf3e9a1c49","8476": "581a9594487f6857","8626": "f8e176634d8305cf","878": "2b37b8f851f4734a","8944": "3467be3781f2bc0f","9384": "d6ff5d2a99bb7acc","9474": "b0838f875bcd3315",}[chunkId] + ".js"
}